(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Bezoekers met 'minder beweging' aan zien een stilstaand beeld. */
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const init = (root) => {
      if (!reduceMotion.matches) return;
      root.querySelectorAll('.ab-hero__video').forEach((video) => video.pause());
    };
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    init(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
